import { render, staticRenderFns } from "./TranslationIcon.vue?vue&type=template&id=6d66a8f2&"
import script from "./TranslationIcon.vue?vue&type=script&lang=ts&"
export * from "./TranslationIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports